import { useNavigate } from "react-router-dom";
import { BoxFiltros, ItensContainer } from "./styles";
import Table from "./Table";
import CriativoIcone from "../../assets/criativo.svg";
import { useState } from "react";
import { ReactSVG } from "react-svg";

export const Criativo = () => {
  const navigate = useNavigate();
  const [statusSelecionado, setStatuSelecionado] = useState("");
  const [textoPesquisa, setTextoPesquisa] = useState("");

  function NovoImposto() {
    navigate("/criativo/novo");
  }

  return (
    <ItensContainer>
      <div className="box">
        <div className="flex">
          <ReactSVG src={CriativoIcone} className="icone" />
          <h1>Criativo</h1>
        </div>
        <BoxFiltros>
          <div className="filtro">
            <input
              placeholder="Pesquisar por ID ou título"
              value={textoPesquisa}
              onChange={(e) => setTextoPesquisa(e.target.value)}
            />
            <div>
              <p>Filtrar por status</p>
              <select
                value={statusSelecionado}
                onChange={(e) => setStatuSelecionado(e.target.value)}
              >
                <option value="">Ver todos</option>
                <option>em andamento</option>
                <option>finalizado</option>
              </select>
            </div>
          </div>
          <button onClick={NovoImposto}>Novo criativo</button>
        </BoxFiltros>
        <Table
          statusSelecionado={statusSelecionado}
          textoPesquisa={textoPesquisa}
        />
      </div>
    </ItensContainer>
  );
};
